import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import ColorPickerProps from './ColorPickerProps'

import Messages from './Messages'
import TileSize from '../Common/TileSize'

export default {
    props: ColorPickerProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Messages,
        TileSize
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoColorPicker(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function(){
            that.$emit('changemodel', that.$refs.valueInput.value)
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoColorPicker()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPicker/KendoColorPickerMixin.js